import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';

export const STUD_GET_STUD = graphql(`
  query StudGetStud(
    $where: AnimalWhereInput!
    $breedCardInfoTranslationsWhere: DogBreedTranslationWhereInput
    $breederCardInfoTranslationsWhere: DogBreederTranslationWhereInput
  ) {
    findManyAnimal(where: $where, take: 1) {
      id
      name
      weight
      size
      imgs {
        id
        small
        medium
        large
      }
      dogInfos {
        id
        pedigree
        color
        coat
        dogBreed {
          ...BreedCardInfo
        }
      }
      studInfos {
        id
        price
        description
        champion
        type
        accomodation
      }
      owner {
        id
        dogBreeder {
          id
          breedingName
          level
          profileImg
          certificationFile
          agreementNumber
          lastConnectedType
          spokenLanguages
          translations(where: $breederCardInfoTranslationsWhere) {
            id
            url
            language
          }
          account {
            id
            firstName
            lastName
            connectedAt
            address {
              id
              region
              country
            }
          }
        }
      }
    }
  }
`);

export const useGetStud = (id: string) => {
  const { language } = useRouter();

  const { data, error, loading } = useQuery(STUD_GET_STUD, {
    variables: {
      where: {
        id: { equals: Number(id) },
        studInfos: { is: { availableForBreeding: { equals: true } } },
      },
    },
    skip: id == null || id === '',
  });

  const stud = data?.findManyAnimal?.[0];
  const translatedDogBreed = {
    ...stud?.dogInfos?.dogBreed,
    translations: [stud?.dogInfos?.dogBreed?.translations.find((t) => t.language === language)],
  };

  return {
    stud,
    breed: translatedDogBreed,
    studLoading: loading,
    studError: error,
  };
};
